// HomeHub gallery thumbnail pager (design node 4464-69812).
// The vertical thumbnail rail shows at most VISIBLE thumbnails; when there
// are more, up/down chevron arrows page through them.
//
// IMPORTANT - do NOT restructure the gallery DOM. Horizon re-renders the
// gallery on variant change with a morph diff (assets/morph.js) against the
// server HTML; if we wrap or re-parent nodes it owns, the morph reconciles
// against an unexpected tree and can detach the whole gallery (the bug this
// version fixes). So this is purely additive:
//   - cap the thumbnails container height via CSS (data-hh-paged + a measured
//     --hh-thumb-max variable), which morph leaves alone, and
//   - append two absolutely-positioned arrow buttons as the LAST children of
//     the slideshow-controls element, without moving the container.
// The arrows are re-created after each morph (morph discards our extra nodes
// when it rebuilds the controls, so we just re-add them).
(function () {
  var VISIBLE = 4;
  var GAP = 8; // matches the rail's flex gap

  function setup(container) {
    if (!container) return;
    var controls = container.closest('slideshow-controls');
    if (!controls) return;
    // Only the vertical (left/right) rail; skip the mobile dot controls.
    var pos = controls.getAttribute('pagination-position');
    if (pos !== 'left' && pos !== 'right') return;

    var strip = container.querySelector('.slideshow-controls__thumbnails');
    var thumbs = strip ? strip.querySelectorAll('.slideshow-controls__thumbnail') : [];

    // Not enough thumbnails: no arrows needed. (The height cap is pure CSS,
    // gated on a 5th thumbnail via :has, so nothing to unset here.)
    if (thumbs.length <= VISIBLE) {
      removeArrows(controls);
      return;
    }

    // The 4-thumbnail height cap lives in CSS (applies the moment the morph
    // inserts the container - no flash). Here we only add + position arrows.
    var th = Math.round(thumbs[0].getBoundingClientRect().height) || 72;

    // (Re)build the arrows fresh so we never accumulate duplicates.
    removeArrows(controls);
    var stepPx = th + GAP;
    var up = makeArrow('up', controls, container, stepPx);
    var down = makeArrow('down', controls, container, stepPx);
    // Arrows are absolutely positioned within slideshow-controls (which can be
    // much TALLER than the thumbnail window - it stretches to the media
    // height). So we can't use top:0 / bottom:0 of the controls; anchor the
    // arrows to the container's own box instead.
    if (getComputedStyle(controls).position === 'static') controls.style.position = 'relative';
    controls.appendChild(up);
    controls.appendChild(down);

    var positionArrows = function () {
      // Container offset relative to the (positioned) controls element.
      var cRect = container.getBoundingClientRect();
      var ctrlRect = controls.getBoundingClientRect();
      var offsetTop = cRect.top - ctrlRect.top;
      var arrowH = up.offsetHeight || 22;
      // Up arrow sits just above the container; down arrow just below it.
      up.style.top = (offsetTop - arrowH) + 'px';
      down.style.top = (offsetTop + container.offsetHeight) + 'px';
      up.style.left = down.style.left = (cRect.left - ctrlRect.left) + 'px';
      up.style.width = down.style.width = container.offsetWidth + 'px';
    };

    var updateArrows = function () {
      var top = container.scrollTop;
      var maxScroll = container.scrollHeight - container.clientHeight;
      up.disabled = top <= 1;
      down.disabled = top >= maxScroll - 1;
    };
    // Re-bind the scroll listener (guard against double-binding on re-setup).
    if (container._hhScroll) container.removeEventListener('scroll', container._hhScroll);
    container._hhScroll = updateArrows;
    container.addEventListener('scroll', updateArrows, { passive: true });
    if (container._hhResize) window.removeEventListener('resize', container._hhResize);
    container._hhResize = positionArrows;
    window.addEventListener('resize', positionArrows, { passive: true });
    positionArrows();
    updateArrows();
  }

  function removeArrows(controls) {
    controls.querySelectorAll('[data-hh-thumb-arrow]').forEach(function (el) { el.remove(); });
  }

  var SVG_NS = 'http://www.w3.org/2000/svg';
  function makeArrow(dir, controls, container, stepPx) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'hh-thumb-arrow hh-thumb-arrow--' + dir;
    b.setAttribute('data-hh-thumb-arrow', dir);
    b.setAttribute('aria-label', dir === 'up' ? 'Previous thumbnails' : 'More thumbnails');
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', 'M6 9l6 6 6-6');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    b.appendChild(svg);
    b.addEventListener('click', function () {
      var d = dir === 'up' ? -1 : 1;
      // Page by (VISIBLE - 1) rows so one row of context carries over.
      container.scrollBy({ top: d * stepPx * (VISIBLE - 1), behavior: 'smooth' });
    });
    return b;
  }

  function scan() {
    document.querySelectorAll('.slideshow-controls__thumbnails-container').forEach(setup);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  var timer = null;
  function scanSoon() {
    clearTimeout(timer);
    timer = window.setTimeout(scan, 80);
  }

  ready(function () {
    scan();
    // Horizon morphs the gallery on variant change. We only append/remove our
    // own [data-hh-thumb-arrow] nodes and position them, so there's no
    // restructuring for morph to fight. The select promise resolves AFTER the
    // morph settles, so scan synchronously there (no debounce) to re-add the
    // arrows in the same frame the new container appears - minimizes the
    // window where arrows are briefly absent. The body observer is the
    // fallback for any path that doesn't fire the event.
    document.addEventListener('shopify:product:select', function (event) {
      var p = event && event.promise;
      if (p && typeof p.then === 'function') p.then(scan).catch(function () {});
      else scan();
    });
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          // Ignore our own arrow inserts to avoid a feedback loop.
          if (n.nodeType === 1 && !n.hasAttribute('data-hh-thumb-arrow')) { scanSoon(); return; }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
